import type { MmkCategory, MmkItem } from "../types/mmk";

export const MAX_PERSONAL_MMK_CARDS = 5;

export const MAX_PERSONAL_CARD_QUESTION_LENGTH = 245;
export const MAX_PERSONAL_CARD_ANSWER_LENGTH = 245;
export const MAX_PERSONAL_CARD_FULL_ANSWER_LENGTH = 500;

export function clampPersonalCardQuestion(value: string): string {
  return value.slice(0, MAX_PERSONAL_CARD_QUESTION_LENGTH);
}

export function clampPersonalCardAnswer(value: string): string {
  return value.slice(0, MAX_PERSONAL_CARD_ANSWER_LENGTH);
}

export function clampPersonalCardFullAnswer(value: string): string {
  return value.slice(0, MAX_PERSONAL_CARD_FULL_ANSWER_LENGTH);
}

export function isPersonalMmkItem(item: Pick<MmkItem, "source">): boolean {
  return item.source === "personal";
}

export type PersonalMmkFormPayload = {
  question: string;
  quickAnswer: string;
  fullApprovedAnswer: string;
  category: MmkCategory | null;
};
